export const CkeditorHelper = {
  getHeadingIndexs: (content) => {
    const contentCopy = content;
    if (!content) {
      return null;
    }
    const startTags = contentCopy.match(/<h([1-6])/g) || [];
    const endTags = contentCopy.match(/<\/h([1-6]>)/g) || [];
    if (startTags.length !== endTags.length || startTags.length === 0) {
      return null;
    }
    const result = [];
    for (let i = 0; i < startTags.length; i++) {
      if (i === 0) {
        result.push({
          start: contentCopy.indexOf(startTags[i]),
          end: contentCopy.indexOf(endTags[i]) + 5,
        });
      } else {
        result.push({
          start: contentCopy.indexOf(
            startTags[i],
            result[result.length - 1].end,
          ),
          end:
            contentCopy.indexOf(endTags[i], result[result.length - 1].end) + 5,
        });
      }
    }
    return result;
  },
  getHeadingArrayWithIndexs: (content, indexs) => {
    if (!content || !indexs || !indexs.length) {
      return null;
    }
    const contentCopy = content;
    const result = [];
    for (let i = 0; i < indexs.length; i++) {
      result.push(contentCopy.slice(indexs[i].start, indexs[i].end));
    }
    return result;
  },
  getHeadingArray: (content) => {
    if (!content) {
      return null;
    }
    const indexs = CkeditorHelper.getHeadingIndexs(content);
    if (!indexs || indexs.length === 0) {
      return null;
    }
    const contentCopy = content;
    const result = [];
    for (let i = 0; i < indexs.length; i++) {
      result.push(contentCopy.slice(indexs[i].start, indexs[i].end));
    }
    return result;
  },
  getHeadingWithId: (content, idPrefix = "section") => {
    const headingArray = CkeditorHelper.getHeadingArray(content);
    if (!headingArray || headingArray.length === 0) {
      return null;
    }
    for (let i = 0; i < headingArray.length; i++) {
      headingArray[i] = headingArray[i]
        .slice(0, 3)
        .concat(" ", `id="${idPrefix}${i + 1}"`, " ", headingArray[i].slice(3))
        .replace("  ", " ");
    }
    return headingArray;
  },
  getHeadingTextArray: (content) => {
    const headingArray = CkeditorHelper.getHeadingArray(content);
    if (!headingArray || headingArray.length === 0) {
      return null;
    }
    const result = headingArray.map((heading) => {
      return heading.slice(heading.indexOf(">") + 1, heading.length - 5);
    });
    return result;
  },
  getTableOfContents: (content, idPrefix = "section") => {
    const headingArray = CkeditorHelper.getHeadingArray(content);
    if (!headingArray || headingArray.length === 0) {
      return null;
    }
    const headingAndLevelArray = headingArray.map((heading) => {
      return {
        heading: heading
          .replace(/(<[span|strong|b|i|em|mark|small|sub|sup].*?>)/g, "")
          .replace(/<\/[span|strong|b|i|em|mark|small|sub|sup]>/g, ""),
        level: parseInt(heading[2]),
      };
    });
    const geAnchorElement = (heading, index) => {
      // Lấy text trong thẻ heading
      let innerText = heading.slice(
        heading.indexOf(">") + 1,
        heading.length - 5,
      );
      // Bỏ số thứ tự thủ công ở đầu (ví dụ: "1. ", "2.1. ", "2.1 ")
      // để tránh trùng lặp với CSS counter tự động
      innerText = innerText.replace(/^(\d+(\.\d+)*\.?\s+)/, "");

      return '<a href="#' + idPrefix + `${index + 1}">` + innerText + "</a>";
    };
    let result = '<ul class="custom-toc">';
    let maxLevel = Math.min(
      ...headingAndLevelArray.map((heading) => heading.level),
    );
    let currentLevel = headingAndLevelArray[0].level;
    for (let i = 0; i < headingAndLevelArray.length; i++) {
      const a = geAnchorElement(headingAndLevelArray[i].heading, i);
      let previoustLevel = currentLevel;
      currentLevel = headingAndLevelArray[i].level;
      if (i === 0) {
        if (currentLevel === maxLevel) {
          result += "<li>" + a;
        } else {
          let j = currentLevel - maxLevel;
          while (j > 0) {
            result += "<li><ul>";
            j -= 1;
          }
          result += "<li>" + a;
        }
      } else {
        if (currentLevel === previoustLevel) {
          result += "</li><li>" + a;
        } else if (currentLevel > previoustLevel) {
          let j = currentLevel - previoustLevel;
          while (j > 1) {
            result += "<ul><li>";
            j -= 1;
          }
          result += "<ul><li>" + a;
        } else {
          let j = previoustLevel - currentLevel;
          while (j > 0) {
            result += "</li></ul>";
            j -= 1;
          }
          result += "</li><li>" + a;
        }
      }
    }
    while (currentLevel >= maxLevel) {
      result += "</li></ul>";
      currentLevel -= 1;
    }

    // Wrap with container and header (giống ảnh mẫu)
    const tocContainer = `
      <div class="toc-container">
        <div class="toc-header">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="toc-icon">
            <path d="M4 6H20M4 12H20M4 18H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 6L4 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 12L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4 18L4 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
           <span class="toc-title">Nội dung bài viết</span>
        </div>
        ${result}
      </div>
    `;
    return tocContainer;
  },
  setContentHeadingId: (content) => {
    if (!content) {
      return content;
    }
    const indexs = CkeditorHelper.getHeadingIndexs(content);
    if (!indexs || indexs.length === 0) {
      return content;
    }
    const headingWithIdArray = CkeditorHelper.getHeadingWithId(
      content,
      "section",
    );
    if (!headingWithIdArray || headingWithIdArray.length === 0) {
      return content;
    }
    const contentCopy = content;
    let contentResult = "";
    for (let i = 0; i < indexs.length; i++) {
      if (i === 0) {
        contentResult = contentResult.concat(
          contentCopy.slice(0, indexs[i].start),
          headingWithIdArray[i],
        );
      } else {
        contentResult = contentResult.concat(
          contentCopy.slice(indexs[i - 1].end, indexs[i].start),
          headingWithIdArray[i],
        );
      }
    }
    contentResult = contentResult.concat(
      contentCopy.slice(indexs[indexs.length - 1].end),
    );
    return contentResult;
  },
  insertTableOfContents: (content, tocCode = "[[toc]]") => {
    if (!content) {
      return content;
    }
    const TableOfContents = CkeditorHelper.getTableOfContents(content);
    if (!TableOfContents) {
      return content;
    }
    let contentCopy = content;
    if (contentCopy.includes(`<p>${tocCode}</p>`)) {
      contentCopy = contentCopy.replace(`<p>${tocCode}</p>`, TableOfContents);
    }
    if (contentCopy.match(/<p.*?>\[\[toc\]\]<\/p>/)) {
      while (contentCopy.match(/<p.*?>\[\[toc\]\]<\/p>/)) {
        const tocKeyBeginIndex = contentCopy.indexOf(tocCode);

        const tocBeginIndex = contentCopy
          .slice(0, tocKeyBeginIndex)
          .lastIndexOf("<p");

        const tocEndIndex = contentCopy.slice(tocKeyBeginIndex).indexOf("</p>");

        contentCopy = contentCopy.replace(
          contentCopy.slice(tocBeginIndex, tocKeyBeginIndex + tocEndIndex + 4),
          TableOfContents,
        );
      }
    } else {
      contentCopy = contentCopy.replace(tocCode, TableOfContents);
    }
    return contentCopy;
  },
  getBlockCodeIndexs: (content) => {
    const contentCopy = content;
    if (!content) {
      return null;
    }
    const startTags = contentCopy.match(/\[\[Block-code=/g) || [];
    const endTags = contentCopy.match(/\]\]/g) || [];
    if (startTags.length !== endTags.length || startTags.length === 0) {
      return null;
    }
    const result = [];
    for (let i = 0; i < startTags.length; i++) {
      if (i === 0) {
        result.push({
          start: contentCopy.indexOf(startTags[i]),
          end: contentCopy.indexOf(endTags[i]) + 2,
        });
      } else {
        result.push({
          start: contentCopy.indexOf(
            startTags[i],
            result[result.length - 1].end,
          ),
          end:
            contentCopy.indexOf(endTags[i], result[result.length - 1].end) + 2,
        });
      }
    }
    return result;
  },
  getBlockCodes: (content) => {
    if (!content) {
      return null;
    }
    const indexs = CkeditorHelper.getBlockCodeIndexs(content);
    if (!indexs || indexs.length === 0) {
      return null;
    }
    let contentCopy = content;
    const result = [];
    for (let i = 0; i < indexs.length; i++) {
      const blockCode = contentCopy.slice(indexs[i].start, indexs[i].end);
      result.push({
        blockCode,
        code: blockCode.slice(blockCode.indexOf("=") + 1, blockCode.length - 2),
      });
    }
    return result;
  },
  insertNewTableOfContents: (content, tableOfContent, tocCode = "[[toc]]") => {
    if (!content) {
      return content;
    }
    // const TableOfContents = CkeditorHelper.getTableOfContents(content);
    const TableOfContents = tableOfContent;
    if (!TableOfContents) {
      return content;
    }
    let contentCopy = content;
    if (contentCopy.includes(`<p>${tocCode}</p>`)) {
      contentCopy = contentCopy.replace(`<p>${tocCode}</p>`, TableOfContents);
    }
    if (contentCopy.match(/<p.*?>\[\[toc\]\]<\/p>/)) {
      while (contentCopy.match(/<p.*?>\[\[toc\]\]<\/p>/)) {
        const tocKeyBeginIndex = contentCopy.indexOf(tocCode);

        const tocBeginIndex = contentCopy
          .slice(0, tocKeyBeginIndex)
          .lastIndexOf("<p");

        const tocEndIndex = contentCopy.slice(tocKeyBeginIndex).indexOf("</p>");

        contentCopy = contentCopy.replace(
          contentCopy.slice(tocBeginIndex, tocKeyBeginIndex + tocEndIndex + 4),
          TableOfContents,
        );
      }
    } else {
      contentCopy = contentCopy.replace(tocCode, TableOfContents);
    }
    return contentCopy;
  },
  extractVideoIdFromOembed(oembedCode) {
    // Tìm chuỗi "youtu.be" trong mã nhúng
    const videoIdIndex = oembedCode.indexOf("youtu.be/");

    // Nếu không tìm thấy "youtu.be", trả về null hoặc thực hiện xử lý phù hợp
    if (videoIdIndex === -1) {
      return null;
    }

    // Lấy video ID bằng cách cắt chuỗi từ "v=" đến ký tự tiếp theo
    const videoIdStart = videoIdIndex + 9;
    const videoId = oembedCode.substring(videoIdStart, videoIdStart + 11); // YouTube video IDs are typically 11 characters

    return videoId;
  },
  extractVideoIdFromOembedNew(oembedCode) {
    // Tìm chuỗi "v=" trong mã nhúng
    const videoIdIndex = oembedCode.indexOf("v=");

    // Nếu không tìm thấy "v=", trả về null hoặc thực hiện xử lý phù hợp
    if (videoIdIndex === -1) {
      return null;
    }

    // Lấy video ID bằng cách cắt chuỗi từ "v=" đến ký tự tiếp theo
    const videoIdStart = videoIdIndex + 2;
    const videoId = oembedCode.substring(videoIdStart, videoIdStart + 11); // YouTube video IDs are typically 11 characters

    return videoId;
  },
  insertIframeMedia: (content) => {
    if (!content) {
      return content;
    }

    let contentCopy = content;

    contentCopy = contentCopy.replace(
      /<oembed[^>]*>(.*?)<\/oembed>/g,
      function (match, embedCode) {
        // Xây dựng thẻ <iframe> từ mã nhúng của <oembed>
        // Ví dụ: Chuyển từ <oembed url="https://www.youtube.com/watch?v=videoId"></oembed>
        // thành <iframe src="https://www.youtube.com/embed/videoId"></iframe>
        if (match?.includes("v=")) {
          var videoId = CkeditorHelper.extractVideoIdFromOembedNew(match); // Hàm để lấy videoId từ mã nhúng
        } else {
          var videoId = CkeditorHelper.extractVideoIdFromOembed(match); // Hàm để lấy videoId từ mã nhúng
        }

        return (
          '<div class="ratio ratio-16x9"><iframe src="https://www.youtube.com/embed/' +
          videoId +
          '" allowFullScreen ></iframe></div>'
        );
      },
    );
    return contentCopy;
  },
};
